import { useState, useCallback } from 'react';
import useRecipeV2Api from './useRecipeV2Api';
import { RecipeV2Detail } from '../types';

const useRecipeV2Detail = () => {
  const { getRecipeDetail } = useRecipeV2Api();
  const [recipe, setRecipe] = useState<RecipeV2Detail | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadRecipe = useCallback(async (id: number) => {
    setIsLoading(true);
    setError(null);
    try {
      const detail = await getRecipeDetail(id);
      setRecipe(detail);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load recipe');
      setRecipe(null);
    } finally {
      setIsLoading(false);
    }
  }, [getRecipeDetail]);

  return { recipe, isLoading, error, loadRecipe, setRecipe };
};

export default useRecipeV2Detail;
